/* eslint-disable max-lines */
import { CSSProperties } from 'react'
import { FONT_WEIGHTS, scaledPx } from '@/styles'
import { TypographyVariantsOptions } from '@mui/material'

const regularFonts: CSSProperties = {
  fontWeight: FONT_WEIGHTS.REGULAR,
}
const mediumFonts: CSSProperties = {
  fontWeight: FONT_WEIGHTS.MEDIUM,
}
const semiBoldFonts: CSSProperties = {
  fontWeight: FONT_WEIGHTS.SEMI_BOLD,
}
const boldFonts: CSSProperties = {
  fontWeight: FONT_WEIGHTS.BOLD,
}

// All sizes are authored at their natural scale and reduced globally by
// `scaledPx` (UI_SCALE) so the type scale matches the 80% density.
const display5xl: CSSProperties = {
  fontSize: scaledPx(100),
  lineHeight: scaledPx(72),
  letterSpacing: '-2%',
}

const display4xl: CSSProperties = {
  fontSize: scaledPx(78),
  lineHeight: scaledPx(72),
  letterSpacing: '-2%',
}

const display3xl: CSSProperties = {
  fontSize: scaledPx(70),
  lineHeight: scaledPx(72),
  letterSpacing: '-2%',
}

const display2xl: CSSProperties = {
  fontSize: scaledPx(72),
  lineHeight: scaledPx(90),
  letterSpacing: '-2%',
}
const displayXl: CSSProperties = {
  fontSize: scaledPx(60),
  lineHeight: scaledPx(72),
  letterSpacing: '-2%',
}
const displayLg: CSSProperties = {
  fontSize: scaledPx(48),
  lineHeight: scaledPx(60),
  letterSpacing: '-2%',
}

const displaySemiLg: CSSProperties = {
  fontSize: scaledPx(45),
  lineHeight: scaledPx(54),
  letterSpacing: '-2%',
}

const displayMd: CSSProperties = {
  fontSize: scaledPx(36),
  lineHeight: scaledPx(44),
  letterSpacing: '-2%',
}
const displaySm: CSSProperties = {
  fontSize: scaledPx(30),
  lineHeight: scaledPx(38),
}

const display2Xs: CSSProperties = {
  fontSize: scaledPx(26),
  lineHeight: scaledPx(32),
}

const displayXs: CSSProperties = {
  fontSize: scaledPx(24),
  lineHeight: scaledPx(32),
}

const displaySemiXs: CSSProperties = {
  fontSize: scaledPx(22),
  lineHeight: scaledPx(32),
}

const textXl: CSSProperties = {
  fontSize: scaledPx(20),
  lineHeight: scaledPx(30),
}
const textLg: CSSProperties = {
  fontSize: scaledPx(18),
  lineHeight: scaledPx(28),
}
const textMd: CSSProperties = {
  fontSize: scaledPx(16),
  lineHeight: scaledPx(24),
}
const textSm: CSSProperties = {
  fontSize: scaledPx(14),
  lineHeight: scaledPx(20),
}
const textXs: CSSProperties = {
  fontSize: scaledPx(12),
  lineHeight: scaledPx(18),
}

export const textConfig: TypographyVariantsOptions = {
  // display5xl
  display5xl: {
    ...display5xl,
    ...regularFonts,
  },
  display5xlMedium: {
    ...display5xl,
    ...mediumFonts,
  },
  display5xlSemibold: {
    ...display5xl,
    ...semiBoldFonts,
  },
  display5xlBold: {
    ...display5xl,
    ...boldFonts,
  },

  // display4xl
  display4xl: {
    ...display4xl,
    ...regularFonts,
  },
  display4xlMedium: {
    ...display4xl,
    ...mediumFonts,
  },
  display4xlSemibold: {
    ...display4xl,
    ...semiBoldFonts,
  },
  display4xlBold: {
    ...display4xl,
    ...boldFonts,
  },

  // display3xl
  display3xl: {
    ...display3xl,
    ...regularFonts,
  },
  display3xlMedium: {
    ...display3xl,
    ...mediumFonts,
  },
  display3xlSemibold: {
    ...display3xl,
    ...semiBoldFonts,
  },
  display3xlBold: {
    ...display3xl,
    ...boldFonts,
  },

  // display2xl
  display2xl: {
    ...display2xl,
    ...regularFonts,
  },
  display2xlMedium: {
    ...display2xl,
    ...mediumFonts,
  },
  display2xlSemibold: {
    ...display2xl,
    ...semiBoldFonts,
  },
  display2xlBold: {
    ...display2xl,
    ...boldFonts,
  },

  // displayXl
  displayXl: {
    ...displayXl,
    ...regularFonts,
  },
  displayXlMedium: {
    ...displayXl,
    ...mediumFonts,
  },
  displayXlSemibold: {
    ...displayXl,
    ...semiBoldFonts,
  },
  displayXlBold: {
    ...displayXl,
    ...boldFonts,
  },

  // displayLg
  displayLg: {
    ...displayLg,
    ...regularFonts,
  },
  displayLgMedium: {
    ...displayLg,
    ...mediumFonts,
  },
  displayLgSemibold: {
    ...displayLg,
    ...semiBoldFonts,
  },
  displayLgBold: {
    ...displayLg,
    ...boldFonts,
  },

  // displaySemiLg
  displaySemiLg: {
    ...displaySemiLg,
    ...regularFonts,
  },
  displaySemiLgMedium: {
    ...displaySemiLg,
    ...mediumFonts,
  },
  displaySemiLgSemibold: {
    ...displaySemiLg,
    ...semiBoldFonts,
  },
  displaySemiLgBold: {
    ...displaySemiLg,
    ...boldFonts,
  },

  // displayMd
  displayMd: {
    ...displayMd,
    ...regularFonts,
  },
  displayMdMedium: {
    ...displayMd,
    ...mediumFonts,
  },
  displayMdSemibold: {
    ...displayMd,
    ...semiBoldFonts,
  },
  displayMdBold: {
    ...displayMd,
    ...boldFonts,
  },

  // displaySm
  displaySm: {
    ...displaySm,
    ...regularFonts,
  },
  displaySmMedium: {
    ...displaySm,
    ...mediumFonts,
  },
  displaySmSemibold: {
    ...displaySm,
    ...semiBoldFonts,
  },
  displaySmBold: {
    ...displaySm,
    ...boldFonts,
  },

  // display2Xs
  display2Xs: {
    ...display2Xs,
    ...regularFonts,
  },
  display2XsMedium: {
    ...display2Xs,
    ...mediumFonts,
  },
  display2XsSemibold: {
    ...display2Xs,
    ...semiBoldFonts,
  },
  display2XsBold: {
    ...display2Xs,
    ...boldFonts,
  },

  // displayXs
  displayXs: {
    ...displayXs,
    ...regularFonts,
  },
  displayXsMedium: {
    ...displayXs,
    ...mediumFonts,
  },
  displayXsSemibold: {
    ...displayXs,
    ...semiBoldFonts,
  },
  displayXsBold: {
    ...displayXs,
    ...boldFonts,
  },

  // displaySemiXs
  displaySemiXs: {
    ...displaySemiXs,
    ...regularFonts,
  },
  displaySemiXsMedium: {
    ...displaySemiXs,
    ...mediumFonts,
  },
  displaySemiXsSemibold: {
    ...displaySemiXs,
    ...semiBoldFonts,
  },
  displaySemiXsBold: {
    ...displaySemiXs,
    ...boldFonts,
  },

  // textXl
  textXl: {
    ...textXl,
    ...regularFonts,
  },
  textXlMedium: {
    ...textXl,
    ...mediumFonts,
  },
  textXlSemibold: {
    ...textXl,
    ...semiBoldFonts,
  },
  textXlBold: {
    ...textXl,
    ...boldFonts,
  },

  // textLg
  textLg: {
    ...textLg,
    ...regularFonts,
  },
  textLgMedium: {
    ...textLg,
    ...mediumFonts,
  },
  textLgSemibold: {
    ...textLg,
    ...semiBoldFonts,
  },
  textLgBold: {
    ...textLg,
    ...boldFonts,
  },

  // textMd
  textMd: {
    ...textMd,
    ...regularFonts,
  },
  textMdMedium: {
    ...textMd,
    ...mediumFonts,
  },
  textMdSemibold: {
    ...textMd,
    ...semiBoldFonts,
  },
  textMdBold: {
    ...textMd,
    ...boldFonts,
  },

  // textSm
  textSm: {
    ...textSm,
    ...regularFonts,
  },
  textSmMedium: {
    ...textSm,
    ...mediumFonts,
  },
  textSmSemibold: {
    ...textSm,
    ...semiBoldFonts,
  },
  textSmBold: {
    ...textSm,
    ...boldFonts,
  },

  // textXs
  textXs: {
    ...textXs,
    ...regularFonts,
  },
  textXsMedium: {
    ...textXs,
    ...mediumFonts,
  },
  textXsSemibold: {
    ...textXs,
    ...semiBoldFonts,
  },
  textXsBold: {
    ...textXs,
    ...boldFonts,
  },
}
